/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.info-container[_ngcontent-%COMP%]    > div[_ngcontent-%COMP%] {\n	margin-bottom: 15px;\n}\n.info-container[_ngcontent-%COMP%]    > div[_ngcontent-%COMP%]    > label[_ngcontent-%COMP%] {\n	width: 150px;\n}\n.info-container[_ngcontent-%COMP%]    > div[_ngcontent-%COMP%]    > input[_ngcontent-%COMP%] {\n	width: calc(100% - 155px);\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvY29tcG9uZW50cy9wb3J0YWwvc3VwZXItdXNlci9sYm0tY29uZmlnL2xibS1lZGl0LW1vZGFsL2xibS1lZGl0LW1vZGFsLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vb3B0L2plbmtpbnMvd29ya3NwYWNlL2dpc2VsYV9wb3J0YWwvc3JjL2FwcC9jb21wb25lbnRzL3BvcnRhbC9zdXBlci11c2VyL2xibS1jb25maWcvbGJtLWVkaXQtbW9kYWwvbGJtLWVkaXQtbW9kYWwuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/portal/super-user/lbm-config/lbm-edit-modal/lbm-edit-modal.component.css.shim.ngstyle.ts